module.exports = __webpack_public_path__ + "static/scale-model-of-chisholm-trail-crossing-park-in-round-rock-texas-15533ca46f485b69224ea6f0a631589a.png";